export default __webpack_public_path__ + "static/media/fo.f284df39.svg";